module.exports = __webpack_public_path__ + "static/media/app-store-badge.7c1b3d44.svg";